import React from "react";
import { Card, Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <Row
      gutter={[16, 16]}
      className="dashcent"
    >
      <Col span={12}>
        <Card
          title="Welcome to Admin Panel"
          style={{ textAlign: "center", borderRadius: 10 }}
        >
          <p style={{ fontSize: 16 }}>Manage your ads & merchants easily.</p>

          <Button
            type="primary"
            size="large"
            onClick={() => navigate("/admin/login-as-merchant")}
          >
            Login as Merchant
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default Dashboard;
